var InFlight = InFlight || {};

InFlight.scrollTo = function(sel, offset) {
  var node = $(sel);
  if (node && node.length > 0) {
    offset = offset || 0;

    var ypos =
      node[0].getBoundingClientRect().top + window.pageYOffset - (offset + 35);
    window.scrollTo(0, ypos);
  }
};
